import actionTypes from '../constants/action-types';

const resetPasswordState = {
  errorResetPassword: null,
};

export const resetPasswordReducer = (state = resetPasswordState, payload) => {
  switch (payload.type) {
    case actionTypes.HANDLE_ERROR_RESET_PASSWORD:
      return { ...state, errorResetPassword: payload.data };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/app/main/reset-password/reducers/reset-password-reducer.js